/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import SEO from './../components/seo';

import Header from './../components/header';
import FooterHome from './../components/footerHome';


const IndexPage = () => {
  return (
    <div className="home">
      <Header transparent = {true}/>
      <SEO title="Mabel Gago | Home"/>
      <FooterHome/>
    </div>
  );
};

export default IndexPage;

